<template>
  <div class="flex w-full h-full min-w-[700px] min-h-[350px]">
    <div class="w-4/6 min-h-full flex-col p-6">
      <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-4/6 absolute rounded-tl-lg left-0 top-0 pointer-events-none" />
      <div class="flex items-center w-full">
        <UserRoundPlus class="z-10 w-12 h-12" color="#000" />
        <span class="z-10 mt-1 ml-2 text-3xl font-bold text-black">{{ $t("Invite your teammates") }}</span>
      </div>
      <div class="z-10 text-common-grey">
        {{ $t("Collaborate with your team to get the most out of RevSetter") }}
      </div>

      <div class="flex flex-col h-full justify-between">
        <div class="flex flex-col">
          <p v-show="false" class="mt-24 text-black font-semibold">
            {{ $t("Invite with link") }}
          </p>
          <div v-show="false" class="mt-1 flex shadow-sm">
            <div class="relative flex items-stretch flex-grow focus-within:z-10">
              <input
                value="https://revsetter.com/invite"
                :disabled="true"
                autocomplete="off"
                :class="[
                  'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light '
                ]"
                class="rounded-br-none rounded-tr-none bg-light-box-background text-common-grey focus:ring-blue focus:border-blue-light block w-full placeholder-common-grey border rounded-lg border-light-divider-border dark:border-dark-divider-border transition ease-in-out duration-side-menu-transition-duration dark:text-dark-body-text">
            </div>
            <button
              type="button"
              class="min-w-[150px] hover:bg-gray-100 bg-light-box-background -ml-px relative inline-flex items-center space-x-2 px-4 py-2 border rounded-bl-none rounded-tl-none border-light-divider-border dark:border-dark-divider-border text-sm font-medium rounded-r-md focus:outline-none transition ease-in-out duration-side-menu-transition-duration"
              @click="sendInvitation()">
              <Copy class="h-5 w-5" aria-hidden="true" />
              <span>{{ $t("Copy link") }}</span>
            </button>
          </div>

          <p class="mt-8 mb-4 text-black font-semibold">
            {{ $t("Send email invitation") }}
          </p>
          <!--
            <div
              v-if="Object.keys(services_users).length"
              class="mx-auto w-full mb-1.5 rounded-lg bg-white dark:bg-dark-box-background border dark:border-dark-divider-border">
              <Disclosure v-for="[service, service_users] in Object.entries(services_users)" v-slot="{ open }" :key="service">
                <DisclosureButton
                  class="flex w-full justify-between rounded-lg px-4 py-2 text-left text-sm font-medium text-blue hover:bg-gray-50 dark:hover:bg-dark-input-background focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75">
                  <span class="capitalize">{{ service }} Users</span>
                  <ChevronUp :class="open ? 'rotate-180 transform' : ''" class="h-5 w-5 text-blue-500" />
                </DisclosureButton>
                <DisclosurePanel class="px-4 pt-4 pb-2 text-sm text-gray-500 max-h-[200px] overflow-scroll">
                  <div
                    v-for="member in service_users.filter((u) => team_members.filter((user) => user.email == u.email).length == 0)"
                    :key="member.email"
                    class="pt-2 flex gap-2">
                    <TextInput v-model="member.first_name" :value="member.first_name" :name="`first_name-${member.email}`" label="First name" />
                    <TextInput v-model="member.last_name" :value="member.last_name" :name="`last_name-${member.email}`" label="Last name" />
                    <TextInput
                      v-model="member.email"
                      :value="member.email"
                      :name="`email-${member.email}`"
                      label="Email"
                      :class="{ 'border-red-error': member.has_error && member.email != '' }" />
                    <div class="relative group w-10">
                      <div class="h-full flex items-center">
                        <Plus
                          class="h-5 w-5 text-blue-500 hover:cursor-pointer hover:text-blue-700 hover:border-2 hover:border-blue-500 hover:rounded-full"
                          aria-hidden="true"
                          @click="addServiceUser(member)" />
                      </div>
                    </div>
                  </div>
                </DisclosurePanel>
              </Disclosure>
            </div>
          -->
          <div v-for="user in users" :key="user">
            <div class="mt-1 flex shadow-sm">
              <div class="relative flex gap-1 items-stretch flex-grow focus-within:z-10">
                <TextInput
                  v-model="user.first_name"
                  :value="user.first_name"
                  :name="`first_name-${user.email}`"
                  :label="$t('First name')" />
                <TextInput v-model="user.last_name" :value="user.last_name" :name="`last_name-${user.email}`" :label="$t('Last name')" />
                <TextInput
                  v-model="user.email"
                  :class="{ 'border-red-error': user?.has_error && user.email != '' }"
                  :value="user.email"
                  :name="`email-${user.email}`"
                  :label="$t('Email')" />
                <SelectDropDownMenu
                  v-model:current-item="user.role"
                  :items="$store.state.auth.user.organization.roles.filter((u) => u.name !== 'EndUser')"
                  :label="$t('Role')"
                  label-attr="name"
                  value-attr="id"
                  :placeholder="$t('Role')"
                  classes="w-fit min-w-[150px] h-[42px]"
                  input-classes="bg-white relative inline-flex items-center space-x-2 h-[42px] px-4 py-2 border border-light-divider-border text-sm font-medium focus:outline-none transition ease-in-out duration-side-menu-transition-duration" />
              </div>
            </div>
          </div>
          <div
            class="flex items-center mt-3 hover:cursor-pointer"
            @click="users.push({ email: '', role: $store.state.auth.user.organization.roles.find((u) => u.name === 'Administrator').id })">
            <span class="flex items-center justify-center rounded-full h-8 w-8 mr-2 bg-[#2DA7D710]">
              <Plus class="text-[#2DA7D7] h-5 w-5" aria-hidden="true" />
            </span>
            <span class="text-[#2DA7D7]">{{ $t("Add another one") }}</span>
          </div>

          <div class="flex mt-6">
            <input
              :checked="allow_signup"
              type="checkbox"
              name="weight"
              class="flex items-center justify-center w-6 h-6 border rounded cursor-pointer focus:ring-blue text-blue-light group-hover:checked:bg-blue-dark dark:bg-transparent dark:border-dark-divider-border"
              @click="
                () => {
                  allow_signup = false
                }
              ">
            <div class="ml-2 dark:text-white">
              {{ $t("Allow anyone with your organization email address to sign up to your team.") }}
            </div>
          </div>
        </div>

        <div class="flex items-center flex-1 flex-row justify-between gap-2 my-5 text-center">
          <span class="text-[#2DA7D7] hover:cursor-pointer" @click="$emit('cancel')">{{ $t("Cancel") }}</span>
          <div
            class="flex cursor-pointer items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-6 font-bold text-white rounded-full w-fit-content h-[50px] content-center text-[14px]"
            @click="sendInvitation()">
            <ShareTeamMembersIcon class="w-7 h-7 ml-1 mr-3" />
            <span> {{ $t("Invite Team Members") }} </span>
          </div>
        </div>
      </div>
    </div>
    <div class="w-2/6">
      <img class="inline-block rounded-r-lg h-full w-full" src="@/assets/invite-teammates.png" alt="">
    </div>
  </div>
</template>
<script>
import ShareTeamMembersIcon from "@/components/shared/icons/ShareTeamMembersIcon.vue"
import { UserRoundPlus, Plus, Copy } from "lucide-vue-next"
import SelectDropDownMenu from "@/components/shared/SelectDropDownMenu.vue"
import TextInput from "@/components/shared/TextInput.vue"
import AuthService from "@/services/auth.service"
export default {
  components: {
    TextInput,
    SelectDropDownMenu,
    Copy,
    UserRoundPlus,
    ShareTeamMembersIcon,
    Plus
  },
  props: {},
  emits: ["done", "cancel", "error"],
  data() {
    return {
      allow_signup: true,
      //services_users: [],
      users: [{ email: "", role: this.$store.state.auth.user.organization.roles.find((u) => u.name === "Administrator").id }]
    }
  },
  methods: {
    sendInvitation() {
      if (this.users.filter((x) => x.email != "").length > 0 && this.users.filter((x) => x.email != "").length == this.users.length) {
        AuthService.inviteTeamMembers(this.users.filter((x) => x.email != ""))
          .then(() => {
            this.$emit("done")
            this.$store.dispatch("data/getUsers")
          })
          .catch(() => {
            this.$emit("error")
          })
      } else {
        if (this.users.filter((x) => x.email != "").length == 0) {
          this.$emit("cancel")
        } else if (this.users.filter((x) => x.email != "").length < this.users.length) {
          this.users = this.users
            .filter((x) => x.email == "")
            .map((x) => {
              x["has_error"] = true
              return x
            })
        }
      }
    }
  }
}
</script>
